import React, { useContext, useEffect, useState } from "react";
import {
  CircularProgress,
  Tooltip,
  Select,
  MenuItem,
  FormControl,
  InputAdornment,
  TextField,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Paper,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  FormHelperText,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { ContextSession } from "../../../services/ContextSession";
import IconButton from "@mui/material/IconButton";
import CryptoJS from "crypto-js";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import Popover from "@mui/material/Popover";
import SearchIcon from "@mui/icons-material/Search";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#19438C",
    color: "white",
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderRight: "none", // Elimina la línea vertical entre columnas
    borderLeft: "none", // Elimina la línea vertical entre columnas
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    // Agrega estilo al pasar el cursor sobre la fila
    backgroundColor: "#C1C1C1", // Cambia el color de fondo al pasar el cursor
  },
}));

function ListaSolicitudesConsAnalistaOP() {
  let sessi = useContext(ContextSession);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [statusFilter, setStatusFilter] = useState("2");
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();

  const estadosConstancia = {
    1: "PENDIENTE",
    2: "PAGADA",
    3: "CANCELADA",
    4: "EMITIDA",
    5: "ANULADA",
  };

  const tiposConstancia = {
    1: "HISTORIAL DE COTIZACIONES",
    2: "RAZONADA",
    3: "SALDOS PROYECTADOS",
    4: "NO TENER PRÉSTAMO ACTIVO",
    5: "TRÁMITE EMBAJADA",
  };

  const obtenerNombreOficina = (idOficina) => {
    const oficinas = {
      1: "Tegucigalpa",
      2: "San Pedro Sula",
      3: "La Ceiba",
      4: "Choluteca",
      5: "Santa Rosa de Copan",
      6: "Santa Barbara",
      7: "Juticalpa",
    };

    return oficinas[idOficina] || idOficina || "-";
  };

  const [searchDNI, setSearchDNI] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterType, setFilterType] = useState("");
  const handleSearchDNIChange = (event) => setSearchDNI(event.target.value);

  const handleFilterClick = (event, type) => {
    setAnchorEl(event.currentTarget);
    setFilterType(type);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
    setFilterType("");
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // const dominio = "http://172.20.7.10:8082";
  //const dominio = "https://be.injupemp.gob.hn:8443";
  //const dominio = "http://127.0.0.1:8000"; -- Error identificado previo al 23 junio 2026 - jsauceda
  const dominio = "https://be.injupemp.gob.hn:8443"; //cambio realizado 23 junio 2026 - jsauceda

  // 1. Mueve fetchData fuera de useEffect
  const fetchData = async () => {
    setLoading(true);
    try {
      const secretKey =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
      const queryString = `IdEstado=${
        statusFilter === "enviada" ? "2" : statusFilter
      }`;
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(
        CryptoJS.enc.Hex
      );

      //const response = await fetch(`http://172.20.7.10:8082/api/ConstanciaPag/Oficial/Estado/?IdEstado=${statusFilter}&IdUser=${sessi.sessionData.id}`, {
      const response = await fetch(
        `${dominio}/api/ConstanciaPag/Oficial/Estado/?IdEstado=${
          statusFilter === "enviada" ? "2" : statusFilter
        }&IdUser=${sessi.sessionData.id}`,
        {
          method: "GET",
          headers: {
            "X-Signature": signature,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) throw new Error("Error al obtener los datos");
      const data = await response.json();
      setRows(data);
    } catch (error) {
      setRows([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [statusFilter]);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filteredRows = rows.filter((row) => {
    if (searchDNI.trim() !== "") {
      const dniMatch =
        row.DNI_usuario &&
        row.DNI_usuario.toString()
          .toLowerCase()
          .includes(searchDNI.toLowerCase());

      // Si no coincide con el DNI, descarta la fila inmediatamente
      if (!dniMatch) return false;
    }

    if (statusFilter === "2")
      return (
        row.fk_id_estado === 2 &&
        row.usuario_asignado !== null &&
        row.enviadaOficina === false
      );
    if (statusFilter === "4")
      return row.fk_id_estado === 4 && row.usuario_asignado !== null;
    if (statusFilter === "enviada")
      return (
        row.fk_id_estado === 2 &&
        row.usuario_asignado !== null &&
        row.enviadaOficina === true
      );
    return true;
  });

  const handleClick = (id) => {
    sessi.setVariable("IDsolConstancia", id);
    navigate("/PortalDelParticipante/VerSolicitudConstancia");
  };

  return (
    <div className="container" style={{ marginTop: 10 }}>
      <>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 10,
          }}
        >
          <h2>
            <b>Lista de Solicitudes de Constancias</b>
          </h2>
        </div>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
            mb: 2,
            mt: 1,
            justifyContent: "center", // <--- Cambia aquí
          }}
        >
          <FormControl size="small" sx={{ minWidth: 170 }}>
            <FormHelperText>Filtrar Constancias:</FormHelperText>
            <Select
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e.target.value);
                setPage(0);
              }}
              displayEmpty
              fullWidth
            >
              <MenuItem value="2">Pagada</MenuItem>
              <MenuItem value="enviada">Enviada a Entrega</MenuItem>{" "}
              <MenuItem value="4">Emitida</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <div className="row" style={{ marginTop: "20px" }}>
          <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
            <Table sx={{ minWidth: 1350 }}>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell>#</StyledTableCell>
                  {/* <StyledTableCell>ID Solicitud</StyledTableCell> */}
                  <StyledTableCell>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <strong>DNI Solicitante</strong>
                      <Tooltip title="Buscar por DNI" arrow>
                        <IconButton
                          onClick={(event) =>
                            handleFilterClick(event, "searchDNI")
                          }
                          color={searchDNI ? "primary" : "default"}
                        >
                          <ManageSearchIcon
                            style={{
                              color: searchDNI ? "#1976d2" : "white",
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </StyledTableCell>
                  <StyledTableCell>Nº Recibo</StyledTableCell>
                  <StyledTableCell>Tipo Constancia</StyledTableCell>
                  <StyledTableCell>Monto</StyledTableCell>
                  <StyledTableCell>Oficina de Entrega</StyledTableCell>
                  <StyledTableCell>Fecha Pagada</StyledTableCell>
                  <StyledTableCell>Fecha Registro</StyledTableCell>
                  <StyledTableCell>Detalle Solicitud</StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Estado
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Acciones
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>

              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleFilterClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
                sx={{
                  p: 2,
                  "& .MuiTextField-root": {
                    m: 1,
                    width: "250px",
                  },
                }}
              >
                {filterType === "searchDNI" && (
                  <Box sx={{ p: 2 }}>
                    <TextField
                      placeholder="Buscar por DNI"
                      aria-label="Buscar por DNI"
                      value={searchDNI}
                      onChange={handleSearchDNIChange}
                      autoFocus
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Box
                      sx={{
                        mt: 1,
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        size="small"
                        onClick={() => setSearchDNI("")}
                        disabled={!searchDNI}
                      >
                        Limpiar
                      </Button>
                    </Box>
                  </Box>
                )}
              </Popover>

              <TableBody>
                {loading ? (
                  <StyledTableRow>
                    <StyledTableCell colSpan={11} align="center">
                      <CircularProgress size={24} />
                    </StyledTableCell>
                  </StyledTableRow>
                ) : filteredRows && filteredRows.length > 0 ? (
                  filteredRows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, idx) => (
                      <StyledTableRow key={row.id_solicitud_constancia}>
                        <StyledTableCell>
                          {page * rowsPerPage + idx + 1}
                        </StyledTableCell>
                        <StyledTableCell>{row.DNI_usuario}</StyledTableCell>
                        <StyledTableCell>{row.numero_recibo}</StyledTableCell>
                        <StyledTableCell>
                          {tiposConstancia[row.fk_id_constancia] ||
                            "DESCONOCIDO"}
                        </StyledTableCell>
                        <StyledTableCell>L.{row.monto}</StyledTableCell>
                        <StyledTableCell>
                          {obtenerNombreOficina(
                            row.FKIdOficina ?? row.fk_id_oficina ?? row.idOficina
                          )}
                        </StyledTableCell>
                        <StyledTableCell>
                          {row.fecha_pagada
                            ? row.fecha_pagada.split("T")[0] +
                              " " +
                              row.fecha_pagada.split("T")[1].substring(0, 8)
                            : "-"}
                        </StyledTableCell>
                        <StyledTableCell>
                          {row.fecha_registro
                            ? row.fecha_registro.split("T")[0] +
                              " " +
                              row.fecha_registro.split("T")[1].substring(0, 8)
                            : "-"}
                        </StyledTableCell>
                        <StyledTableCell>
                          {row.detalle_solicitud}
                        </StyledTableCell>
                        <StyledTableCell style={{ textAlign: "center" }}>
                          <span
                            style={{
                              backgroundColor:
                                row.subsanando === true
                                  ? "#ff9800ff"
                                  : row.recepcionOficina === true &&
                                    row.oficinaEntregaParticipante === false
                                  ? "#00c3ffff"
                                  : row.fk_id_estado === 6
                                  ? "#a37e0dd5"
                                  : row.fk_id_estado === 1
                                  ? "#22c1e9d3"
                                  : row.fk_id_estado === 2
                                  ? "#46a091ff"
                                  : row.fk_id_estado === 3
                                  ? "#ff0000d5"
                                  : row.fk_id_estado === 4
                                  ? "#21964eff"
                                  : row.fk_id_estado === 5
                                  ? "#ff3d3dd5"
                                  : "#b3b325ff",
                              borderRadius: 10,
                              color:
                                row.subsanando === true ? "white" : "black",
                              padding: 10,
                              width: "150px",
                              display: "inline-block",
                            }}
                          >
                            {row.subsanando === true
                              ? "SUBSANANDO"
                              : row.recepcionOficina === false &&
                                row.oficinaEntregaParticipante === false &&
                                row.enviadaOficina === true
                              ? "PENDIENTE DE RECIBIR"
                              : row.recepcionOficina === true &&
                                row.oficinaEntregaParticipante === false
                              ? "LISTA PARA ENTREGA"
                              : estadosConstancia[row.fk_id_estado] ||
                                "DESCONOCIDO"}
                          </span>
                        </StyledTableCell>
                        <StyledTableCell>
                          <Box display="flex" justifyContent="center">
                            <Tooltip
                              title="Ver Solicitud"
                              arrow
                              placement="left-start"
                            >
                              <IconButton
                                onClick={() =>
                                  handleClick(row.id_solicitud_constancia)
                                }
                              >
                                <VisibilityIcon
                                  sx={{ color: "green", fontSize: 30 }}
                                />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                ) : (
                  <StyledTableRow>
                    <StyledTableCell colSpan={11} align="center">
                      No hay datos.
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            labelRowsPerPage={"Filas por página"}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </>
    </div>
  );
}

export default ListaSolicitudesConsAnalistaOP;
